import { config } from './config';
import { getCaptchaToken } from './captcha';
import { stableStringify } from './stableStringify';
import { generateEphemeralKeyPair, exportPublicJWK } from '../services/dpop';

export interface MintContext {
  keypair?: CryptoKeyPair;
  publicJwk?: Record<string, unknown>;
}

export async function mintToken(formData: Record<string, string>): Promise<{ token?: string; context: MintContext }>{
  const captchaToken = await getCaptchaToken();

  const context: MintContext = {};
  const payload: Record<string, unknown> = {
    form: formData,
    captcha_token: captchaToken,
  };

  if (config.mode === 'dpop') {
    const keypair = await generateEphemeralKeyPair();
    const publicJwk = await exportPublicJWK(keypair.publicKey);
    payload.cnf = { jwk: publicJwk };
    context.keypair = keypair;
    context.publicJwk = publicJwk as Record<string, unknown>;
  }

  const body = stableStringify(payload);

  const options: RequestInit = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
  };
  if (config.mode === 'cookie') options.credentials = 'include';

  const res = await fetch(config.mintUrl, options).catch(() => {
    throw new Error('Unable to connect to the server. Please check your internet connection and try again.');
  });
  if (!res.ok) {
    throw new Error('Server error: Unable to process your request. Please try again later.');
  }
  let data: { token?: string } = {};
  try { data = await res.json(); } catch {}
  return { token: data.token, context };
}


